/**
 * チバリヨ - バージョン情報 (単一の真実のソース = package.json の version)
 *
 * ビルド時に build.mjs が esbuild の define で __APP_VERSION__ / __APP_BUILD__ を
 * 実値へ置換する。
 *   - __APP_VERSION__ : セマンティックバージョン (例 "1.0.0")
 *   - __APP_BUILD__   : ビルド識別子 (git short hash。無ければ生成値)
 *
 * 生ファイル(未ビルドの public/ 直配信)では define が効かないため、
 * typeof ガードでフォールバックする (ReferenceError を避ける)。
 */

/* eslint-disable no-undef */
export const APP_VERSION =
  (typeof __APP_VERSION__ !== 'undefined') ? __APP_VERSION__ : 'dev';
export const APP_BUILD =
  (typeof __APP_BUILD__ !== 'undefined') ? __APP_BUILD__ : 'local';
/* eslint-enable no-undef */

/** 表示用ラベル (例: "v1.0.0") */
export const APP_VERSION_LABEL = 'v' + APP_VERSION;

/** ビルド識別子付き詳細ラベル (例: "v1.0.0 (build ba6ef15)") */
export const APP_VERSION_FULL =
  APP_BUILD && APP_BUILD !== 'local'
    ? `v${APP_VERSION} (build ${APP_BUILD})`
    : `v${APP_VERSION}`;
